const DashboardReportPage = () => <div />;

export default DashboardReportPage;
